import { useSnackbarContext } from '@/contexts/SnackbarContext';
import Input from '@superfunnel/ui-core/v2/Input';
import { useState } from 'react';
import { OnboardingChips } from './OnboardingChips';
import { StepContentLayout } from './StepContentLayout';
import { OnboardingFormData, StepContentProps } from './StepContentProps';

export const OnboardingStep5 = ({
  data,
  onChange,
  onNext,
  onBack,
  isLoading = false,
  disabled,
}: StepContentProps) => {
  const { show } = useSnackbarContext();
  const [referralSource, setReferralSource] = useState<
    OnboardingFormData['referralSource'] | ''
  >(data.referralSource || '');
  const [referralSourceOther, setReferralSourceOther] = useState(
    data.referralSourceOther || '',
  );

  const handleSubmit = () => {
    if (!referralSource) {
      show('Please select a referral source to continue.', 'warn');
      return;
    }
    onChange((prev) => ({
      ...prev,
      referralSource,
      referralSourceOther,
    }));
    onNext();
  };

  const referralOptions = [
    { value: 'linkedin', label: 'LinkedIn' },
    { value: 'google', label: 'Google Search' },
    { value: 'referral', label: 'Referral from someone' },
    { value: 'conference', label: 'Conference or event' },
    { value: 'friend', label: 'Friend or colleague' },
    { value: 'other', label: 'Other' },
  ];

  return (
    <StepContentLayout
      showBackButton={!!onBack}
      onBack={onBack}
      onNext={handleSubmit}
      nextButtonText="Start Building Super Funnels"
      isLoading={isLoading}
      nextButtonDisabled={!referralSource}
      disabled={disabled}
    >
      <div className="space-y-4">
        <OnboardingChips
          options={referralOptions.map((o) => o.label)}
          value={
            referralOptions.find((o) => o.value === referralSource)?.label || ''
          }
          onChange={(value) => {
            const option = referralOptions.find((o) => o.label === value);
            setReferralSource(option?.value as any);
            onChange((prev) => ({
              ...prev,
              referralSource:
                option?.value as OnboardingFormData['referralSource'],
            }));
          }}
          disabled={disabled}
        />
        {referralSource === 'other' && (
          <Input
            type="text"
            value={referralSourceOther}
            onChange={(e) => {
              setReferralSourceOther(e.target.value);
              onChange((prev) => ({
                ...prev,
                referralSourceOther: e.target.value,
              }));
            }}
            placeholder="Please specify..."
            disabled={disabled}
          />
        )}
      </div>
    </StepContentLayout>
  );
};
